export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const MAGIC_LINK_TOKEN_PARAM = 'token';
export const SSO_DATA_PARAM = 'data';
